import { useContext } from 'react';
import CMSRouteParamsContext from './CMSRouteParamsContext';
const useCmsRouteParams = () => {
  const cmsRouteParamsValue = useContext(CMSRouteParamsContext);
  return cmsRouteParamsValue;
};
export default useCmsRouteParams;